// extracted by mini-css-extract-plugin
export default {"headerContent":"Rbzjp","title":"I4RKE"};